export default "__VITE_ASSET__CRYQLXRl__"